import { Navigate, Outlet } from 'react-router-dom'

import { useMeQuery } from '../store/api'
import type { PlanPackageType } from '../store/types/billing'
import SpinLoader from '../utils/loaders/spin'

export default function PackageCheck({
  allowed,
}: {
  allowed: PlanPackageType[]
}) {
  const { data } = useMeQuery()

  if (data && data.package_type) {
    if (
      allowed.includes(data.package_type) ||
      data.register_source === 'Shopify'
    ) {
      return <Outlet />
    }
    return <Navigate to={'/'} replace />
  }
  return <SpinLoader />
}
